module.exports = __webpack_public_path__ + "img/swiper2.e35444e4.jpg";